import { IconShare } from "@tabler/icons-react";
import { useToast } from "../../contexts/ToastContext";
import Button from "./Button";

export const ShareButton = ({ text, ...props }) => {
  const { showToast } = useToast();
  const handleCopyMessage = async () => {
    try {
      await navigator.clipboard.writeText(text);
      showToast("Message copied to clipboard!", "success");
    } catch (err) {
      showToast("Failed to copy message", "error");
    }
  };
  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          text,
        });
      } catch (error) {
        // Handle share error if needed
      }
    } else {
      handleCopyMessage();
    }
  };

  return (
    <Button
      variant="tertiary"
      onClick={handleShare}
      startIcon={<IconShare size={16} />}
      {...props}
    >
      Share
    </Button>
  );
};
